// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Shared SVG store populated by per-entry registries
const store = {};
export default store;
